"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var csod = require("player-core");
function view() {
    var _this = this;
    return {
        state: {
            locationsTitle: ""
        },
        initialize: function () {
            return new Promise(function (resolve) {
                _this.view.helpers.refreshLocationsTitle();
                resolve();
            });
        },
        mounted: function () {
        },
        receivedProps: function (nextProps) {
            return new Promise(function (resolve) {
                _this.view.helpers.refreshLocationsTitle(nextProps.locations);
                resolve();
            });
        },
        unmount: function () {
        },
        events: {},
        helpers: {
            refreshLocationsTitle: function (locations) {
                if (locations === void 0) { locations = _this.props.locations; }
                var localizedLocationsTitle = csod.locales.get("Job available in these locations:", "Job available in these locations:");
                _this.view.state.locationsTitle = locations.length ? localizedLocationsTitle : "";
            }
        }
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/.tmp/JobDetailsLocations/View.js
// module id = 795
// module chunks = 0